function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function resolveProps(tokens, _ref) {
  var _start;

  var flow = _ref.flow,
      indicator = _ref.indicator,
      next = _ref.next,
      offset = _ref.offset,
      onError = _ref.onError,
      parentIndent = _ref.parentIndent,
      startOnNewline = _ref.startOnNewline;
  var spaceBefore = false;
  var atNewline = startOnNewline;
  var hasSpace = startOnNewline;
  var comment = '';
  var commentSep = '';
  var hasNewline = false;
  var reqSpace = false;
  var tab = null;
  var anchor = null;
  var tag = null;
  var newlineAfterProp = null;
  var comma = null;
  var found = null;
  var start = null;

  var _iterator = _createForOfIteratorHelper(tokens),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var token = _step.value;

      if (reqSpace) {
        if (token.type !== 'space' && token.type !== 'newline' && token.type !== 'comma') onError(token.offset, 'MISSING_CHAR', 'Tags and anchors must be separated from the next token by white space');
        reqSpace = false;
      }

      if (tab) {
        if (atNewline && token.type !== 'comment' && token.type !== 'newline') {
          onError(tab, 'TAB_AS_INDENT', 'Tabs are not allowed as indentation');
        }

        tab = null;
      }

      switch (token.type) {
        case 'space':
          // At the doc level, tabs at line start may be parsed
          // as leading white space rather than indentation.
          // In a flow collection, only the parser handles indent.
          if (!flow && (indicator !== 'doc-start' || (next === null || next === void 0 ? void 0 : next.type) !== 'flow-collection') && token.source.includes('\t')) {
            tab = token;
          }

          hasSpace = true;
          break;

        case 'comment':
          {
            if (!hasSpace) onError(token, 'MISSING_CHAR', 'Comments must be separated from other tokens by white space characters');
            var cb = token.source.substring(1) || ' ';
            if (!comment) comment = cb;else comment += commentSep + cb;
            commentSep = '';
            atNewline = false;
            break;
          }

        case 'newline':
          if (atNewline) {
            if (comment) comment += token.source;else spaceBefore = true;
          } else commentSep += token.source;

          atNewline = true;
          hasNewline = true;
          if (anchor || tag) newlineAfterProp = token;
          hasSpace = true;
          break;

        case 'anchor':
          if (anchor) onError(token, 'MULTIPLE_ANCHORS', 'A node can have at most one anchor');
          if (token.source.endsWith(':')) onError(token.offset + token.source.length - 1, 'BAD_ALIAS', 'Anchor ending in : is ambiguous', true);
          anchor = token;
          if (start === null) start = token.offset;
          atNewline = false;
          hasSpace = false;
          reqSpace = true;
          break;

        case 'tag':
          {
            if (tag) onError(token, 'MULTIPLE_TAGS', 'A node can have at most one tag');
            tag = token;
            if (start === null) start = token.offset;
            atNewline = false;
            hasSpace = false;
            reqSpace = true;
            break;
          }

        case indicator:
          // Could here handle preceding comments differently
          if (anchor || tag) onError(token, 'BAD_PROP_ORDER', "Anchors and tags must be after the ".concat(token.source, " indicator"));
          if (found) onError(token, 'UNEXPECTED_TOKEN', "Unexpected ".concat(token.source, " in ").concat(flow !== null && flow !== void 0 ? flow : 'collection'));
          found = token;
          atNewline = indicator === 'seq-item-ind' || indicator === 'explicit-key-ind';
          hasSpace = false;
          break;

        case 'comma':
          if (flow) {
            if (comma) onError(token, 'UNEXPECTED_TOKEN', "Unexpected , in ".concat(flow));
            comma = token;
            atNewline = false;
            hasSpace = false;
            break;
          }

        // else fallthrough

        default:
          onError(token, 'UNEXPECTED_TOKEN', "Unexpected ".concat(token.type, " token"));
          atNewline = false;
          hasSpace = false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var last = tokens[tokens.length - 1];
  var end = last ? last.offset + last.source.length : offset;

  if (reqSpace && next && next.type !== 'space' && next.type !== 'newline' && next.type !== 'comma' && (next.type !== 'scalar' || next.source !== '')) {
    onError(next.offset, 'MISSING_CHAR', 'Tags and anchors must be separated from the next token by white space');
  }

  if (tab && (atNewline && tab.indent <= parentIndent || (next === null || next === void 0 ? void 0 : next.type) === 'block-map' || (next === null || next === void 0 ? void 0 : next.type) === 'block-seq')) onError(tab, 'TAB_AS_INDENT', 'Tabs are not allowed as indentation');
  return {
    comma: comma,
    found: found,
    spaceBefore: spaceBefore,
    comment: comment,
    hasNewline: hasNewline,
    anchor: anchor,
    tag: tag,
    newlineAfterProp: newlineAfterProp,
    end: end,
    start: (_start = start) !== null && _start !== void 0 ? _start : end
  };
}

export { resolveProps };